module.exports = __webpack_public_path__ + "img/JonathanPaillassonVierge.827a40ad.png";